/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './verifiedcsvselectview.tpl.html';

angular
  .module('bulkExport.verifiedCsvSelectView', ['services.error', 'services.util'])
  // These keys are used for sorting the records
  .constant(
    'SortKeys',
    Object.freeze({
      NAME: 'sfName',
      SFID: 'sfId'
    })
  )
  /**
   * Controller for the bulkExport.verifiedCsvSelectView template.
   */
  .controller('BulkExportVerifiedCsvSelectViewCtrl', [
    '$scope',
    '$uibModal',
    '$filter',
    '$rootScope',
    '$window',
    '$state',
    'pagingUtils',
    'BulkRestoreService',
    'ErrorService',
    'MomentFormats',
    'SortKeys',
    'UtilService',
    'WizardService',
    'batchUtils',
    'UserAgentFactory',
    'CHECKED_STATUS',
    'BULK_RESTORE_EVENTS',
    'ALERT_EVENTS',
    function (
      $scope,
      $uibModal,
      $filter,
      $rootScope,
      $window,
      $state, //angular and third party injections
      pagingUtils,
      BulkRestoreService,
      ErrorService,
      MomentFormats,
      SortKeys,
      UtilService,
      WizardService,
      batchUtils,
      UserAgentFactory, // spanning services
      CHECKED_STATUS,
      BULK_RESTORE_EVENTS,
      ALERT_EVENTS
    ) {
      if (!$state.params.bulkRestoreData) {
        throw new Error('bulkRestoreData is required');
      }

      var i18n = $filter('i18n');
      var pluralize = $filter('pluralize');
      var previewModalOpened = false;
      var bulkRestoreData = $state.params.bulkRestoreData;
      var modalInstance, model, pagingInfo, toastMessage;

      // Published functions
      $scope.downloadInvalidIds = downloadInvalidIds;
      $scope.getBackupBatchDateText = getBackupBatchDateText;
      $scope.getHeaderClass = getHeaderClass;
      $scope.hasDuplicateRecords = hasDuplicateRecords;
      $scope.hasInvalidRecords = hasInvalidRecords;
      $scope.setPage = setPage;
      $scope.setRecordsAndPagingInfo = setRecordsAndPagingInfo;
      $scope.shouldShowPaging = shouldShowPaging;
      $scope.showPreview = showPreview;
      $scope.sortRecords = sortRecords;
      $scope.toggleSelectingAll = toggleSelectingAll;
      $scope.updateRecords = updateRecords;

      // Publish the bulk restore data
      $scope.bulkRestoreData = bulkRestoreData;
      $scope.SortKeys = SortKeys;

      // Set the initial paging values.
      pagingInfo = pagingUtils.pagingInfo.bulkRestoreAllRecords;
      pagingInfo.currentPage = 1;

      // Store data in a model object rather than the scope itself for easier watching
      $scope.model = model = {
        instanceUrl: $rootScope.instanceUrl,
        itemsFoundText: '',
        pagingInfo: pagingInfo
      };

      initWizardPage();
      watchScopeDestroy();
      var removePagingEventListener = watchPagingEvent();
      setCompletedRestoreToastNotification();

      // Retrieve the records
      bulkRestoreData.setSelectingAll(true);
      $scope.updateRecords();

      /**
       * Function to set the toast notification message.
       */
      function setCompletedRestoreToastNotification() {
        var batch = bulkRestoreData.getCsvCompletedBulkRestoreBatch();
        if (batch) {
          var batchDateStr = moment(batch.batchDate).format(MomentFormats.BATCH);
          var msgKey = bulkRestoreData.isCrossOrgRestore()
            ? 'CROSS_ORG_RESTORE_COMPLETED_FROM_CSV'
            : 'RESTORE_COMPLETED_FROM_CSV';
          toastMessage = i18n(msgKey, [batchDateStr]);
          $rootScope.$emit(ALERT_EVENTS.SUCCESS.eventName, toastMessage, true, null);
        }
      }

      /**
       * Sets up this page for use with the wizard service.
       */
      function initWizardPage() {
        // Register our page with the wizard service
        var page = WizardService.getCurrentPage();
        page.setHeaderText(i18n('SELECT_EXPORT_ITEMS'));
        page.setStateParams($state.params);
        page.setValid(isValid);
        // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this
        // far.
        page.setTouched(true);
      }

      /**
       * Watches for the scope to be destroyed so we can clean up.
       */
      function watchScopeDestroy() {
        // Need to close modal if opened.
        $scope.$on('$destroy', function () {
          if (previewModalOpened && modalInstance) {
            modalInstance.close();
          }
          if (removePagingEventListener) {
            removePagingEventListener();
            removePagingEventListener = null;
          }
        });
      }

      /**
       * Watches for an event from the paging controls.
       *
       * @returns {Function} a function that can be used to remove the watcher
       */
      function watchPagingEvent() {
        // bind $rootScope.$on bulk restore preview page to keep paging in sync.
        return $rootScope.$on(BULK_RESTORE_EVENTS.PAGING_EVENT, function (event, currentPage) {
          setPage(currentPage);
        });
      }

      /**
       * Updates the records and paging utilities values based on the result returned
       * from the server.
       *
       * @returns {Promise} a promise that resolves when the records are updated
       */
      function updateRecords() {
        var pagingParams = {
          page: pagingInfo.currentPage - 1,
          pageSize: pagingInfo.itemsPerPage,
          sort: pagingInfo.sortBy,
          ascending: pagingInfo.ascending
        };

        $rootScope.showLoadingMask = true;

        return BulkRestoreService.getCsvVerificationResults(bulkRestoreData, pagingParams)
          .then(function (results) {
            setRecordsAndPagingInfo(results);
          })
          .catch(function (err) {
            ErrorService.report(err, i18n('DELETED_ITEMS_RECORDS_FAILED'));
          })
          .finally(function () {
            $rootScope.showLoadingMask = false;
          });
      }

      /**
       * Utility to set the current records and paging info.
       *
       * @param {{numberOfRecords: number, records: object[]}} results - The CSV verification results.
       */
      function setRecordsAndPagingInfo(results) {
        bulkRestoreData.setTotalObjectRecordCount({
          count: results.numberOfRecords
        });
        bulkRestoreData.setPageObjectRecords(results.records);

        pagingInfo.totalItems = results.numberOfRecords;
        pagingInfo.totalPages = Math.ceil(pagingInfo.totalItems / pagingInfo.itemsPerPage);

        model.itemsFoundText = pluralize(pagingInfo.totalItems, 'ITEM_FOUND', 'ITEMS_FOUND');
      }

      /**
       * Utility to update the current page selected and fetch records.
       *
       * @param {Number|String} pageNo - The page number to update the current page.
       * @returns {promise} A promise that when resolved will include a records object.
       */
      function setPage(pageNo) {
        var page = pagingUtils.getCurrentPage(pageNo, pagingInfo.totalPages) || pagingInfo.currentPage;

        if (page) {
          pagingInfo.currentPage = page;
        }

        // Update paging parameters
        pagingUtils.updateBulkRestoreAllRecords(pagingInfo);
        $scope.updateRecords();
      }

      /**
       * Toggles the "select all" value.
       */
      function toggleSelectingAll() {
        bulkRestoreData.setSelectingAll(!bulkRestoreData.isSelectingAll());
      }

      /**
       * Sorts the object records by the specified key.
       *
       * @param {string} sortKey - The sort key.
       */
      function sortRecords(sortKey) {
        if (pagingInfo.sortBy !== sortKey) {
          // Start with ascending when we switch to a new column
          pagingInfo.sortBy = sortKey;
          pagingInfo.ascending = true;
        } else {
          // Toggle the direction when we stay on the same column
          pagingInfo.ascending = !pagingInfo.ascending;
        }

        pagingUtils.updateBulkRestoreAllRecords(pagingInfo);
        $scope.updateRecords();
      }

      /**
       * Returns the class to be used to style a header in the record list.
       *
       * @param {string} sortKey - The sort key used to identify the header.
       * @returns {string} The class to use.
       */
      function getHeaderClass(sortKey) {
        var headerClass = '';
        if (pagingInfo.sortBy === sortKey) {
          if (pagingInfo.ascending) {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          }
        }
        return headerClass;
      }

      /**
       * Download a CSV of IDs that did not match records in the selected backup.
       *
       * @returns {Promise} a promise that resolves when the ids are downloaded.
       */
      function downloadInvalidIds() {
        return BulkRestoreService.downloadInvalidIdCsv(bulkRestoreData.getCsvBatchId())
          .then(function (result) {
            var browser = UserAgentFactory.detectBrowser();
            var blob;

            // If it's IE do some black magic and use custom IE specific methods (MsSaveBlob) to save this file.
            if (browser && browser.indexOf('IE') > -1) {
              if (window.navigator.msSaveOrOpenBlob) {
                blob = new Blob([decodeURIComponent(encodeURI(result))], {
                  type: 'text/csv;charset=utf-8;'
                });
                navigator.msSaveBlob(blob, 'BulkRestoreInvalidIds.csv');
              }
            } else {
              // convert to data URI
              $window.location.href = 'data:text/csv;charset=utf8,' + encodeURI(result);
            }
          })
          .catch(function (err) {
            ErrorService.report(err);
          });
      }

      /**
       * Handler for launching the preview modal.
       *
       * @param {object} $event - The event object triggered.
       * @param {number} recordIndex - the selected record index in records array.
       */
      function showPreview($event, recordIndex) {
        $event.preventDefault();
        $event.stopPropagation();

        // Scroll to where the modal will appear
        UtilService.scrollHome();

        modalInstance = $uibModal.open({
          templateUrl: 'bulkRestore/modal/preview.tpl.html',
          controller: 'PreviewRecordCtrl',
          windowClass: 'sbsf-bulkrestore-modal-window sbsf-bulk-restore-modal',
          backdrop: false,
          resolve: {
            bulkRestoreData: function () {
              return bulkRestoreData;
            },
            recordIndex: function () {
              return recordIndex;
            }
          }
        });

        modalInstance.opened.then(function () {
          previewModalOpened = true;
        });

        modalInstance.result.finally(function () {
          previewModalOpened = false;
          // Go back where we started
          UtilService.scrollToElement(`record-${recordIndex}`);
        });
      }

      /**
       * Determines whether the settings on the page are valid (i.e. Next is allowed in the wizard)
       *
       * @returns {boolean} true if the settings are valid, false otherwise.
       */
      function isValid() {
        // We need a selection
        return !bulkRestoreData.isCsvFailed() && bulkRestoreData.getSelectedObjectRecordCount() > 0;
      }

      /**
       * Returns the formatted date of the verified backup batch.
       *
       * @returns {string} the formatted date string
       */
      function getBackupBatchDateText() {
        return moment(bulkRestoreData.getBackupBatchDate()).format(MomentFormats.BATCH);
      }

      /**
       * Determines whether there were any duplicate records found during the verification.
       *
       * @returns {boolean} true if there were any duplicate records found
       */
      function hasDuplicateRecords() {
        return bulkRestoreData.getCsvDuplicateCount() > 0;
      }

      /**
       * Determines whether there were any invalid records found during the verification.
       *
       * @returns {boolean} true if there were any invalid records found
       */
      function hasInvalidRecords() {
        return bulkRestoreData.getCsvInvalidCount() > 0;
      }

      /**
       * Determines whether the paging controls should be displayed.
       *
       * @returns {boolean} true if the paging controls should be displayed.
       */
      function shouldShowPaging() {
        return pagingInfo.totalPages > 1;
      }
    }
  ]);
